

angular
.module('inkfinder')
.factory('updatePasswordFactory', function updatePasswordFactory(
  AlertMessages,
  $http,
  ENDPOINT
) {
  // Send your current and new passwords to the server
  updatePasswordFactory.updatePassword = function(request) {
    return $http.post(ENDPOINT.server +
    'collectors/api/v1.1/password/change/', {
      current_password: request.current_password,
      password1: request.new_password,
      password2: request.new_password_confirm
    })
    .then(function(response) {
      AlertMessages.add({
        msg: response.data,
        type: 'success'});
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'});
    });
  };
  return updatePasswordFactory;
});



// WEBPACK FOOTER //
// ./components/collector/update-password/update-password.service.js